import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnNG: CultureInfo = {
  name: 'ff-Latn-NG',
  displayName: 'Pulaar (Latn, Nijeriyaa)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-NG',
  parent: CultureInfoFfLatn
};
